export default __webpack_public_path__ + "static/media/maxresdefault.534f348e.png";